export default __webpack_public_path__ + "static/20-aefa7c0a8d5e11a116f2dc0a372a6ca2.webp";